import { render, staticRenderFns } from "./CreditAssessmentReportPreview.vue?vue&type=template&id=18838419&scoped=true"
import script from "./CreditAssessmentReportPreview.vue?vue&type=script&lang=js"
export * from "./CreditAssessmentReportPreview.vue?vue&type=script&lang=js"
import style0 from "./CreditAssessmentReportPreview.vue?vue&type=style&index=0&id=18838419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18838419",
  null
  
)

export default component.exports